import ModalCourseSchedulingSessionFormModule from './containers/modalCourseSchedulingSessionFormModule'

export {default as ModalCourseSchedulingSessionFormModuleLayout} from './components/modalCourseSchedulingSessionFormModuleLayout'

export default ModalCourseSchedulingSessionFormModule
